// extracted by mini-css-extract-plugin
module.exports = {"root":"MetaBlock_root__2WNye","creator":"MetaBlock_creator__35BMO"};